var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hue-palette-well",style:({'background-color': _vm.colorRGBA}),on:{"click":_vm.setColor}})}
var staticRenderFns = []

export { render, staticRenderFns }